import { axiosNT } from '../../../services/axios';

const list = () => axiosNT.get(`/subSubject/`)
	.then((res: any) => Promise.resolve(res.responseObject));

const listBySubjects = (id: string, classId: string = "") => axiosNT.get(`/subSubject/bySubjectId/${id}?classId=${classId}`)
	.then((res: any) => Promise.resolve(res.responseObject));

const listBySubjectsByGoal = (subjectIds: any[], courseTypeIds: any[]) => axiosNT.post(`/courseSyllabus/v4/sub-subject`, {
	courseTypeIds,
	subjectIds
}).then((res: any) => Promise.resolve(res.responseObject.subSubjects));

const byId = (id: string) => axiosNT.get(`/subSubject/${id}`)
	.then((res: any) => Promise.resolve(res.responseObject));

export default {
	list,
	byId,
	listBySubjects,
	listBySubjectsByGoal
}